import React from 'react';

export const AppContext = React.createContext();

export const useAppContext = () => {
  const context = React.useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext deve ser usado dentro de AppContext.Provider');
  }
  return context;
};
